import React, { useEffect, useState } from "react";
import AdminHead from "./AdminHead";
import { db } from "../Components/Firebase";
import {
  collection,
  getDocs,
  addDoc,
  deleteDoc,
  doc
} from "firebase/firestore";
import "../Styles/Admin/Catalog.css";
import Loading from "../Components/Loading";
import { useNavigate , useParams} from "react-router-dom";

function Catalog() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newCollectionName, setNewCollectionName] = useState("");
  const {UID} = useParams()
  const nav = useNavigate()

  useEffect(() => {
    fetchCatalog();
  }, []);

  const fetchCatalog = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, "Catalog"));
      const data = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setCollections(data);
    } catch (error) {
      console.error("שגיאה בטעינת הקטלוג:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddCollection = async () => {
    if (!newCollectionName.trim()) return;
    try {
      await addDoc(collection(db, "Catalog"), {
        name: newCollectionName.trim(),
        created: new Date()
      });
      setNewCollectionName("");
      fetchCatalog();
    } catch (error) {
      console.error("שגיאה ביצירת קולקציה חדשה:", error);
    }
  };

  const handleDeleteCollection = async (id) => {
    if (!window.confirm("האם אתה בטוח שברצונך למחוק את הקולקציה הזו?")) return;
    try {
      await deleteDoc(doc(db, "Catalog", id));
      fetchCatalog();
    } catch (error) {
      console.error("שגיאה במחיקת הקולקציה:", error);
    }
  };

  if (loading) {
    return <Loading/>
  }

  return (
    <React.Fragment>
      <AdminHead />
      <div className="catalog-container" dir="rtl">
        <h1 className="catalog-title">קטלוג מוצרים</h1>

        <div className="add-collection-form">
          <input
            type="text"
            placeholder="שם קולקציה חדשה"
            value={newCollectionName}
            onChange={(e) => setNewCollectionName(e.target.value)}
          />
          <button onClick={handleAddCollection}>+ הוסף קולקציה</button>
        </div>

        {collections.map((collection) => (
          <div key={collection.id} className="collection-section">
            <div className="collection-header">
              <h2>{collection.name}</h2>
              {collection.created && (
                <p className="collection-created">
                  נוצר בתאריך: {new Date(collection.created.seconds * 1000).toLocaleDateString()}
                </p>
              )}
              <div>
                <button className="view-btn" onClick={() => nav(`/AdminHome/${UID}/Catalog/${collection.id}`)}>
                  צפייה
                </button>
                <button className="delete-btn" onClick={() => handleDeleteCollection(collection.id)}>
                  מחק
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default Catalog;
